(function () {

	"use strict";
	angular.module("harriApp")
		.directive('employeeDropdown', ['$state', '$filter', function ($state, $filter) {
			return {
				restrict: "E",
				replace: 'true',
				scope: {
					brand: '=?',
					selectedEmployee: '=',
					employeesList: '=',
					onSearchReset: '&',
					onEmployeeSelected: '&',
					onDropdownToggled: '&',
					hideCount: '=?',
					placeholder: '@?',
					name: '@?'
				},
				templateUrl: '../modules/team_schedule/employer/employee-dropdown/views/employee_dropdown_directive.html',
				link: function (scope, element, attrs) {

					scope.isEmployeesDropdownOpen = false;

					//toggle the employees dropdown menu
					scope.toggleEmployeesDropdown = function () {
						scope.isEmployeesDropdownOpen = !scope.isEmployeesDropdownOpen;
						if (scope.isEmployeesDropdownOpen === true) {
							setTimeout(function () {
                                element.find('#employee-search-filter').focus();
							}, 10);
						}
						scope.onDropdownToggled({isOpen: scope.isEmployeesDropdownOpen});
					};

					scope.employeeSearchFilter = "";
					scope.resetSearch = function (force) {
						if (scope.employeeSearchFilter != "" || force) {
							scope.employeeSearchFilter = "";
                            scope.selectedEmployee = undefined;
							scope.onSearchReset();
                            triggerChange();
						}
					};

					scope.searchFilterKeyUp = function ($event) {
						if ($event.keyCode == 27) {
							scope.toggleEmployeesDropdown();
						}
						else if ($event.keyCode == 40) {
							setTimeout(function () {
								if (element.find('.employees-dropdown-menu li.employee-wrap.active')) {
                                    element.find('.employees-dropdown-menu li.employee-wrap.active').focus();
								}
								else {
                                    element.find('.employees-dropdown-menu li.employee-wrap:first-child').focus();
								}
							}, 10);
						}
						else if ($event.keyCode == 38) {
							if (element.find('.employees-dropdown-menu li.employee-wrap.active')) {
								setTimeout(function () {
                                    element.find('.employees-dropdown-menu li.employee-wrap.active').focus();
								}, 10);
							}
						}
					};

					scope.selectDropdownEmployee = function (employee) {

						if (scope.selectedEmployee != employee) {
                            scope.selectedEmployee = employee;
                            if (scope.selectedEmployee && (scope.selectedEmployee.first_name || scope.selectedEmployee.last_name)) {
                                scope.employeeSearchFilter = employee.first_name + ' ' + employee.last_name;
                            }

                            scope.onEmployeeSelected({employee: scope.selectedEmployee});
                            triggerChange();
                        }

						scope.toggleEmployeesDropdown();
					};

					scope.selectEmployeeOnEnter = function ($event, employee) {
						if ($event.keyCode == 13) {
							scope.selectDropdownEmployee(employee);
						}
					};

					var triggerChange = function () {

                        setTimeout(function () {
                            scope.$digest();
                            element.find('input[type="text"]').change();
                        }, 10);
                    };

                    element.find('.employees-dropdown-menu').on('focus', 'li', function () {
						var $this = $(this);
						$this.addClass('active').siblings().removeClass('active');
						$this.closest('.employees-dropdown-menu li.employee-wrap').scrollTop($this.index() * $this.outerHeight());
					})
							.on('keydown', 'li', function (e) {
								var $this = $(this);
								if (e.keyCode == 40) {
									$this.next().focus();
									return false;
								} else if (e.keyCode == 38) {
									$this.prev().focus();
									return false;
								} else if (e.keyCode == 27) {
									scope.toggleEmployeesDropdown();
								}
							})
							.find('li').first().focus();

					scope.$on("$destroy", function () {
                        element.find('.employees-dropdown-menu').off('focus').off('keydown');
					});

				}
			}
		}]);
})();